<div class="practice-test" [ngClass]="{ 'no-top-margin': roleId == 4 }">
  <div class="practice-test__header">
    <ng-container *ngFor="let course of courses">
      <span
        class="practice-test__header__item"
        [ngClass]="{
          'practice-test__header__item--active': selectedTest === course
        }"
        (click)="filterTests(course)"
        >{{ course }}</span
      >
    </ng-container>
  </div>
  <div class="practice-test__body">
    <ng-container *ngIf="courses.length > 0">
      <input
        type="text"
        [(ngModel)]="testFilter"
        placeholder="Search"
        (keyup)="filterTestsByName()"
      />
      <ng-container
        *ngFor="let test of textFilteredTests; let testIndex = index"
      >
        <ng-container *ngIf="selectedTest === test.testTypeName">
          <div class="practice-test__body__test">
            <div class="practice-test__body__test__item">
              <span class="practice-test__body__test__item__text-primary">{{
                test.testCode
              }}</span>
              <span class="practice-test__body__test__item__text">{{
                test.completeBy
              }}</span>
            </div>
            <div class="practice-test__body__test__item">
              <span class="practice-test__body__test__item__text"
                >Test Type:</span
              >
              <span class="practice-test__body__test__item__text-bold">{{
                test.testTypeName
              }}</span>
            </div>
            <div class="practice-test__body__test__item">
              <span class="practice-test__body__test__item__text">Status</span
              ><span class="practice-test__body__test__item__text-bold">
                {{
                  test.status === 3
                    ? "Completed"
                    : test.status === 2
                    ? "Started"
                    : test.status === 4
                    ? "Expired"
                    : "Not Started"
                }}
              </span>
            </div>
            <button
              class="practice-test__body__test__item__button practice-test__body__test__item__button--reset"
              *ngIf="role === '3' && (test.status === 2 || test.status === 3)"
              (click)="retakeTestDetails = test; showRetake = true"
            >
              <mat-icon>replay</mat-icon> Retake
            </button>
            <button
              *ngIf="
                (role !== '4' && test.status !== 4) ||
                (role === '4' && test.status === 3)
              "
              class="practice-test__body__test__item__button"
              [ngClass]="{
                'practice-test__body__test__item__button--active':
                  test.status === 3
              }"
              (click)="
                goToTest(test.status, test.studentTestId, test.testTypeName)
              "
            >
              {{
                test.status === 3
                  ? "View Report"
                  : test.status === 2
                  ? "Continue Test"
                  : "Start Test"
              }}
            </button>
            <ng-container *ngIf="test.status === 3">
              <ng-container
                *ngFor="let section of test.section_score | keyvalue : sortFn"
              >
                <div class="practice-test__body__test__item">
                  <span class="practice-test__body__test__item__text-strong">{{
                    section.key + " Score"
                  }}</span>
                  <span
                    class="practice-test__body__test__item__text-primary practice-test__body__test__item__text-primary--active"
                    >{{ $any(section.value).score }}
                    <span class="practice-test__body__test__item__text-sub"
                      >out of
                      {{
                        test.isDPSAT
                          ? 760
                          : test.isDPSAT9
                          ? 720
                          : $any(section.value).max
                      }}</span
                    >
                  </span>
                </div>
              </ng-container>
              <!-- <button
              *ngIf="test.status !== 4"
              class="practice-test__body__test__item__button"
              [ngClass]="{
                'practice-test__body__test__item__button--reset':
                  test.status === 3
              }"
              [routerLink]="
                test.status === 3
                  ? ['/report', test.studentTestId]
                  : ['/online-test', test.studentTestId]
              "
            >
              Reset<mat-icon>replay</mat-icon>
            </button> -->
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container
      *ngIf="textFilteredTests.length === 0 && !loading && courses.length !== 0"
    >
      No tests to display
    </ng-container>
    <ng-container *ngIf="courses.length === 0 && !loading">
      No Courses to display
    </ng-container>
  </div>
</div>

<p-dialog
  [showHeader]="false"
  [resizable]="false"
  styleClass="practice-test__loader"
  [(visible)]="showLoader"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="false"
  appendTo="body"
>
  <p-progressSpinner> </p-progressSpinner>
</p-dialog>

<p-dialog
  [resizable]="false"
  [(visible)]="showRetake"
  [closable]="true"
  class="practice-test__dialog"
  [styleClass]="'practice-test__dialog'"
  header="Are you sure you want to retake the test?"
  [modal]="true"
  [breakpoints]="{ '960px': '90vw' }"
  [style]="{ width: '50vw' }"
  appendTo="body"
>
  <div class="practice-test__dialog__buttons">
    <button
      class="practice-test__dialog__buttons--button"
      (click)="retakeTestDetails = null; showRetake = false"
    >
      <mat-icon>close</mat-icon>No</button
    ><button
      class="practice-test__dialog__buttons--button"
      (click)="retakeTest()"
    >
      <mat-icon>done</mat-icon>Yes
    </button>
  </div>
</p-dialog>
